
import React from "react";
import InputMask from "react-input-mask";
import { Input } from "./input";
import { cn } from "@/lib/utils";

export interface MaskedInputProps extends React.ComponentProps<typeof Input> {
  mask: string;
  maskChar?: string | null;
  formatChars?: Record<string, string>;
  alwaysShowMask?: boolean;
}

const MaskedInput = React.forwardRef<HTMLInputElement, MaskedInputProps>(
  ({ className, mask, maskChar = "_", formatChars, alwaysShowMask = false, ...props }, ref) => {
    return (
      <InputMask
        mask={mask}
        maskChar={maskChar}
        formatChars={formatChars}
        alwaysShowMask={alwaysShowMask}
        {...props}
      >
        {(inputProps: any) => (
          <Input 
            className={cn(className)} 
            ref={ref}
            {...inputProps}
          />
        )}
      </InputMask>
    );
  }
);

MaskedInput.displayName = "MaskedInput";

export { MaskedInput };
